export const GET_NOTIFY_STATUS_LIST = "GET_NOTIFY_STATUS_LIST";
export const GET_NOTIFY_TYPE_LIST = "GET_NOTIFY_TYPE_LIST";

export const NOTIFY_LIST_ACTION = "NOTIFY_LIST_ACTION";
